import React from "react";

const Badge = ({ color, label }) => {
  const getColor = () => {
    switch (color) {
      case "red":
        return "bg-red-50 text-red-700 ring-red-700/10";
      case "yellow":
        return "bg-yellow-50 text-yellow-700 ring-yellow-500/10";
      case "green":
        return "bg-green-50 text-green-700 ring-green-500/10";
      case "blue":
        return "bg-blue-50 text-blue-700 ring-blue-500/10";
      case "indigo":
        return "bg-indigo-50 text-indigo-700 ring-indigo-500/10";
      case "purple":
        return "bg-purple-50 text-purple-700 ring-purple-500/10";
      case "pink":
        return "bg-pink-50 text-pink-700 ring-pink-500/10";
      case "gray":
        return "bg-gray-50 text-gray-600 ring-gray-500/10";
      default:
        return "bg-gray-50 text-gray-600 ring-gray-500/10";
    }
  };

  return (
    <span
      className={`inline-flex items-center rounded-md  px-2 py-1 text-xs font-medium ring-1 ring-inset  ${getColor()}`}
    >
      {label}
    </span>
  );
};

export default Badge;
